export const footerLinksData = [
  {
    path: "/about",
    name: "About Us",
  },
  {
    path: "/our-menu",
    name: "Our Menu",
  },
  {
    path: "/reservation",
    name: "Reservations",
  },
]
